import OwnerTab from "./OwnerTab";

export default OwnerTab